import { reactive, toRefs } from '@vue/composition-api';
import TWEEN from '@tweenjs/tween.js';

import { updateNote, moveNotes } from '../use/useDocActions';
import { pagesModule } from '@/store/database/pagesModule';

export default () => {
  const state = reactive({
    pz: null,
    mainPageId: null,
    selectedCardRefs: [],
    selectedCardsParent: null,
    draggingCard: false,
    draggingCardParentPageId: null,
    dragOutCard: false,
    hoveringTag: false,
    spaced: false,
    showAddNewCard: false,
    newCard: { x: 0, y: 0 },
    hoverContainer: null,
    hoverPage: null,
    dropZoneHover: false,
    editing: null
  });

  const setState = (s, value) => {
    console.log('set ' + s, value);
    state[s] = value;
  };

  const setDragStart = ({ note, pageId, coord, nested }) => {
    state.pz.pause();
    state.draggingCard = note;
    state.draggingCardParentPageId = pageId;
    if (nested) {
      //  setup the dragOutCard
      const { x, y } = coord;
      state.dragOutCard = { ...note, x, y };
    } else if (coord) {
      const { x, y } = coord;
      const update = { x, y };
      updateNote({ pageId, note, update });
    }
    console.log(state);
  };

  const updateCardPositions = event => {
    const { x, y } = event; //event
    if (state.dragOutCard) {
      //  dragging the dragOutCard, just update the ghost.
      state.dragOutCard.x = x;
      state.dragOutCard.y = y;
      return;
    }

    //  dragging a real card. update it to db.
    const draggingCard = state.draggingCard;
    const result = [{ id: draggingCard.id, ...event }];
    const selectedDragCard = state.selectedCardRefs.find(q => q.note.id == draggingCard.id);
    if (selectedDragCard) {
      // the dragged card is a selected card. Move all selected cards
      //  get the reactive draggingCard
      state.selectedCardRefs.forEach(card => {
        if (card.note.id !== selectedDragCard.note.id) {
          const diffX = card.note.x - selectedDragCard.note.x;
          const diffY = card.note.y - selectedDragCard.note.y;
          result.push({ id: card.note.id, x: x + diffX, y: y + diffY });
        }
        // result.push({ id: card.value.id, x: x + diffX, y: y + diffY });
      });
    }
    console.log('update card positions', result);
    result.forEach(r => {
      const { id, x, y } = r;
      const update = { x, y };
      updateNote({ pageId: state.draggingCardParentPageId, noteId: id, update });
    });
  };

  const handleDragEnd = () => {
    console.log('handle page drag end');
    state.pz.resume();
    const draggingCard = state.dragOutCard || state.draggingCard;

    if (
      (state.hoverContainer && state.hoverContainer.id != draggingCard.id) ||
      (state.hoveringTag && state.hoveringTag.pageId !== state.draggingCardParentPageId) ||
      state.dragOutCard
    ) {
      //  we are dropping into a different page
      let position;
      let hoverContainerPageId = state.mainPageId;
      if (state.hoverContainer) {
        hoverContainerPageId = state.hoverContainer.pageId;
      } else if (state.hoveringTag) {
        hoverContainerPageId = state.hoveringTag.pageId;
      }
      const hoverContainerPage = pagesModule.doc(hoverContainerPageId).data;

      if (state.dropZoneHover) {
        //  we are sorting this note, get the position
        position = hoverContainerPage.pageNotes[state.dropZoneHover].order;
      } else {
        //   just put it at the end
        position = Object.values(hoverContainerPage.pageNotes).filter(
          n => !n.toDelete && n !== undefined && n.id
        ).length;
      }

      moveNotes({
        noteIds: [draggingCard.id],
        moveToPageId: hoverContainerPageId,
        moveFromPageId: state.draggingCardParentPageId,
        moveToPosition: position
      });

      if (state.dragOutCard && !state.hoverContainer) {
        //  update the note with the new position
        const update = { x: state.dragOutCard.x, y: state.dragOutCard.y };
        updateNote({ pageId: hoverContainerPageId, noteId: draggingCard.id, update });
      }
    }

    setState('draggingCard', false);
    setState('dragOutCard', false);
    setState('draggingCardParentPageId', false);
  };

  //makeGrid JUST creates a layout with xy coodrinates.  It does not perform the move.
  const makeGrid = ({
    pageId = state.mainPageId,
    cards,
    newColVertThreshold = 600,
    initialX = 20,
    initialY = 20,
    horizPadding = 25,
    vertPadding = 20,
    columnFirstMethod = true,
    maxCols = 3,
    isSelection = false
  }) => {
    //should try catch this
    if (cards.length == 0) {
      return {};
    }
    console.log('makeGrid refs:', cards);
    const columnSpacing = Number(cards[0].width) + horizPadding;
    console.log('column width is ', columnSpacing);
    let cardPositions = [];
    let colCurrentBottoms = new Array(maxCols).fill(initialY);
    let cardX;
    let cardY;
    let currentCol = 0;
    let cardHeight;
    console.log('col bottom:', colCurrentBottoms);

    if (isSelection) {
      if (columnFirstMethod == true) {
        cards.sort((firstCard, secondCard) => {
          return firstCard.note.y - secondCard.note.y;
        });
      } else {
        cards.sort((firstCard, secondCard) => {
          return firstCard.note.x - secondCard.note.x;
        });
      }
    }
    // ----- go through all the cards and generate locations for each card----
    // Choice A: by columns.
    if (columnFirstMethod) {
      cards.forEach((card, index) => {
        cardHeight = card.$el.getBoundingClientRect().height / state.pz.getTransform().scale;
        cardX = initialX + currentCol * columnSpacing;
        cardY = colCurrentBottoms[0] + vertPadding;
        colCurrentBottoms[0] += vertPadding + cardHeight;
        if (colCurrentBottoms[0] > newColVertThreshold + initialY) {
          currentCol += 1;
          colCurrentBottoms[0] = initialY;
        }
        cardPositions.push({ x: cardX, y: cardY, id: card.note.id });
      });
      // Choice B: by rows.
    } else {
      console.log('arranging by row first');
      cards.forEach((card, index) => {
        cardHeight = card.$el.getBoundingClientRect().height / state.pz.getTransform().scale;
        cardX = initialX + currentCol * columnSpacing;
        cardY = colCurrentBottoms[currentCol] + vertPadding;
        colCurrentBottoms[currentCol] += vertPadding + cardHeight;
        const minBottom = Math.min(...colCurrentBottoms);
        currentCol = colCurrentBottoms.indexOf(minBottom);

        cardPositions.push({ x: cardX, y: cardY, id: card.note.id });
      });
    }
    // ---- Once the positions have been determined, set up the TWEEN move ----
    TweenMoveCards(cards, cardPositions, pageId);

    // ---- Carry out the TWEEN move
    animate();
    function animate() {
      if (TWEEN.update()) {
        requestAnimationFrame(animate);
      }
    }
  };

  const makeGridSelected = ({
    pageId = state.mainPageId,
    cards = state.selectedCardRefs,
    newColVertThreshold = 600,
    horizPadding = 25,
    vertPadding = 20,
    columnFirstMethod = true,
    maxCols = 3,
    isSelection = true
  }) => {
    let initialPosition = getSelectedCardBounds(cards);
    const initialX = initialPosition.left;
    const initialY = initialPosition.top;
    makeGrid({
      pageId,
      cards,
      newColVertThreshold: newColVertThreshold,
      horizPadding: horizPadding,
      vertPadding: vertPadding,
      maxCols: maxCols,
      initialX,
      initialY,
      columnFirstMethod: columnFirstMethod,
      isSelection: isSelection
    });
  };

  const getSelectedCardBounds = cards => {
    let left = Infinity;
    let top = Infinity;

    cards.forEach(card => {
      let cardX = 0;
      let cardY = 0;
      if (card.note.x === undefined || card.note.y === undefined) {
        console.log('Updating old card without x,y positions to have x,y = 0,0');
      } else {
        cardX = card.note.x;
        cardY = card.note.y;
      }
      if (cardX < left) {
        left = cardX;
      }
      if (cardY < top) {
        top = cardY;
      }
    });

    return { left: left, top: top };
  };

  const cardsAreAllNew = cards => {
    let allCardsAreNew = true;
    cards.forEach(card => {
      if (card.note.x != undefined && card.note.y != undefined) {
        if (card.note.x != 0 || card.note.y != 0) {
          console.log('Found a non 0,0 card');
          allCardsAreNew = false;
        }
      }
    });
    return allCardsAreNew;
  };

  const TweenMoveCards = (cards, cardPositions, pageId) => {
    cardPositions.forEach((cardPosition, index) => {
      let coords = {};
      if (cards[index].note.x === undefined || cards[index].note.y === undefined) {
        coords = { x: 0, y: 0 };
      } else {
        coords = {
          x: cards[index].note.x,
          y: cards[index].note.y
        };
      }
      console.log('coords', coords);
      const distance = 1;
      console.log('distance: ' + distance);
      const tween = new TWEEN.Tween(coords) // Create a new tween that modifies 'coords'.
        .to({ x: cardPosition.x, y: cardPosition.y }, 500 * distance + Math.random() * 300)
        .easing(TWEEN.Easing.Cubic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          let update = { x: coords.x, y: coords.y };
          if (coords.x === undefined || coords.y === undefined) {
            console.log('found some undefined x or y!');
            update = { x: 0, y: 0 };
          }
          updateNote({ pageId: pageId, noteId: cardPosition.id, update });
        })
        .start(); // Start the tween immediately.
    });
  };

  // const TweenMoveCard = (card, cardPosition, pageId) => {
  //   const coords = { x: 0, y: 0 };
  //   const tween = new TWEEN.Tween(coords) // Create a new tween that modifies 'coords'.
  //     .to({ x: cardPosition.x + 300, y: cardPosition.y + 300 }, 600) // Move to (300, 200) in 1 second.
  //     .easing(TWEEN.Easing.Cubic.Out) // Use an easing function to make the animation smooth.
  //     .onUpdate(() => {
  //       // Called after tween.js updates 'coords'.
  //       // Move 'box' to the position described by 'coords' with a CSS translation.
  //       // box.style.setProperty('transform', `translate(${coords.x}px, ${coords.y}px)`);
  //       const update = { x: coords.x, y: coords.y };
  //       updateNote({ pageId: pageId, noteId: cardPosition.id, update });
  //       // console.log('tween ---- moving card', card, coords);
  //     })
  //     .start(); // Start the tween immediately.
  // };

  return {
    state: toRefs(state),
    setState,
    setDragStart,
    updateCardPositions,
    handleDragEnd,
    makeGrid,
    makeGridSelected,
    cardsAreAllNew
  };
};
